import React from 'react'
import { InputEditorFunc, areEditorPropsEqual } from '@/components/report-tables/editors/fInputEditor'
import { isDotNetNullableDecimalCompatible } from '@/utils/numberUtilities'

const FloatEditorFunc = React.memo(function FloatEditorFunc (props) {
  return <InputEditorFunc validateValue={isDotNetNullableDecimalCompatible} {...props} />
}, areEditorPropsEqual)

export { FloatEditorFunc }



// WEBPACK FOOTER //
// ./src/components/report-tables/editors/fFloatEditor.js